import useTranslate from "../../../../app/hooks/useTranslate";
import HandIcon from "../../../../app/icons/HandIcon";
import { AsideMenuItem } from "./AsideMenuItem";
import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";
import {
  canShowMenuItem,
  getAuthUser,
  isPortalAdmin,
  isVirtualUser,
} from "../../../../utils/permissions";

export function AsideMenuMain() {
  const t = useTranslate();
  const user = getAuthUser();
  const isAdmin = isPortalAdmin(user);

  const showAccountManagement =
    canShowMenuItem("accounts") || !isVirtualUser(user);

  const showOperations =
    showAccountManagement ||
    canShowMenuItem("devices") ||
    canShowMenuItem("monitor") ||
    canShowMenuItem("tracker_pairing") ||
    canShowMenuItem("quick_pair_imeis") ||
    canShowMenuItem("quick_transfers");

  const showReports = isAdmin || canShowMenuItem("sold_reports");

  const showAdministration =
    isAdmin || window.location.pathname === "/user/change-password";

  return (
    <>
      {showOperations && <div className="kp-aside-section">Operations</div>}

      {showAccountManagement && (
        <AsideMenuItemWithSub
          to="/users"
          title="Account Management"
          fontIcon="bi-people"
          matchPaths={["/virtual-accounts"]}
        >
          {canShowMenuItem("accounts") && (
            <AsideMenuItem
              to="/users"
              title="Dealers & End Users"
              hasBullet={true}
            />
          )}
          {!isVirtualUser(user) && (
            <AsideMenuItem
              to="/virtual-accounts"
              title="Team Members"
              hasBullet={true}
            />
          )}
        </AsideMenuItemWithSub>
      )}

      {canShowMenuItem("devices") && (
        <AsideMenuItem to="/devices" fontIcon="bi-cpu" title="Devices" />
      )}

      {canShowMenuItem("monitor") && (
        <AsideMenuItem to="/monitors" fontIcon="bi-display" title="Monitor" />
      )}

      {canShowMenuItem("tracker_pairing") && (
        <AsideMenuItem
          to="/tracker-pairing"
          fontIcon="bi-camera"
          title="Pair IMEI - Camera"
        />
      )}

      {canShowMenuItem("quick_pair_imeis") && (
        <AsideMenuItem
          to="/quickPairImeis"
          icon={<HandIcon />}
          title="Pair IMEI - Manual Entry"
        />
      )}

      {canShowMenuItem("quick_transfers") && (
        <AsideMenuItem
          to="/quickTransfers"
          fontIcon="bi-arrow-left-right"
          title="Quick Customer Transfer"
        />
      )}

      {showReports && <div className="kp-aside-section">Reports</div>}

      {isAdmin && (
        <AsideMenuItem
          to="/vin-error-reports"
          fontIcon="bi-exclamation-triangle"
          title="VIN Error Reports"
        />
      )}

      {canShowMenuItem("sold_reports") && (
        <AsideMenuItem
          to="/sold-reports"
          fontIcon="bi-receipt"
          title="Sold Reports"
        />
      )}

      {showAdministration && (
        <div className="kp-aside-section">Administration</div>
      )}

      {isAdmin && (
        <AsideMenuItemWithSub to="/keyper" title="KEYper" fontIcon="bi-key-fill">
          <AsideMenuItem
            to="/keyper/assets"
            title="Assets"
            fontIcon="bi-box-seam"
          />
          <AsideMenuItem
            to="/keyper/systems"
            title="Systems"
            fontIcon="bi-hdd-rack"
          />
        </AsideMenuItemWithSub>
      )}

      {isAdmin && (
        <AsideMenuItem
          to="/welcomeEmailLogs"
          fontIcon="bi-envelope-open"
          title="Welcome Email Logs"
        />
      )}

      {isAdmin && (
        <AsideMenuItem
          to="/welcomeSmsLogs"
          fontIcon="bi-chat-dots"
          title="SMS Logs"
        />
      )}

      {isAdmin && (
        <AsideMenuItem
          to="/rolesManagement"
          fontIcon="bi-shield-lock"
          title="Roles Management"
        />
      )}

      {window.location.pathname === "/user/change-password" && (
        <AsideMenuItem
          to="/user"
          fontIcon="bi-key"
          title={t("CHANGE_PASSWORD")}
        />
      )}
    </>
  );
}
